var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Down_Arrow_3_ Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.563197545
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.000000, -183.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0000256,17 C13.8605258,17 13.7208896,16.9429795 13.6143898,16.8290842 L8.15985205,10.9957813 C7.94671598,10.767845 7.94671598,10.3987427 8.15985205,10.1709522 C8.37298811,9.94316175 8.71812398,9.94301592 8.93112368,10.1709522 L14.0000256,15.5918407 L19.0689275,10.1709522 C19.2820635,9.94301592 19.6271994,9.94301592 19.8401991,10.1709522 C20.0531988,10.3988885 20.0533351,10.7679908 19.8401991,10.9957813 L14.3856614,16.8290842 C14.2791615,16.9429795 14.1395254,17 14.0000256,17 Z",
    transform: "translate(14.000000, 13.500000) rotate(-270.000000) translate(-14.000000, -13.500000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e58cfd29.svg";
export { ForwardRef as ReactComponent };